(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Provider', Provider);

    Provider.$inject = ['$resource', 'DateUtils'];

    function Provider($resource, DateUtils) {
        var resourceUrl = 'api/providers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'getAsList': {
                method: 'GET',
                isArray: true,
                url: 'api/provider-list'
            },
            'getAllByCategory': {
                method: 'GET',
                isArray: true,
                url: 'api/provider-categories/:id/providers'
            }
        });
    }
})();
